<ion-content class="re-hub-scroll home-page">
  <div class="home-shell re-page-shell">
    <header class="home-topbar">
      <ion-button class="home-topbar__btn" shape="round" fill="clear" routerLink="/friends"
        [attr.aria-label]="'friends.title' | translate">
        <ion-icon slot="icon-only" name="people-circle-outline"></ion-icon>
      </ion-button>
      <ion-button class="home-topbar__btn" shape="round" fill="clear" routerLink="/profile"
        [attr.aria-label]="'profile.title' | translate">
        <ion-icon slot="icon-only" name="person-circle-outline"></ion-icon>
      </ion-button>
    </header>

    <div class="home-layout">
      <section class="home-hero">
        <span class="home-hero__version">v{{ version }}</span>
        <h1 class="home-hero__brand">
          <re-app-brand-logo variant="full" />
        </h1>
        <div class="home-hero__divider" aria-hidden="true"></div>
        <p class="home-hero__welcome">
          {{ 'profile.welcome' | translate: { displayName: profile()?.displayName } }}
        </p>
      </section>

      <section class="home-credits">
        @defer (when tabPagesReady()) {
          <re-credits-summary />
        } @placeholder {
        <article class="home-credits-skeleton" aria-hidden="true">
          <div class="home-credits-skeleton__head">
            <ion-skeleton-text animated class="home-credits-skeleton__icon"></ion-skeleton-text>
            <div class="home-credits-skeleton__copy">
              <ion-skeleton-text animated
                class="home-credits-skeleton__line home-credits-skeleton__line--eyebrow"></ion-skeleton-text>
              <ion-skeleton-text animated
                class="home-credits-skeleton__line home-credits-skeleton__line--value"></ion-skeleton-text>
            </div>
          </div>
          <div class="home-credits-skeleton__pockets">
            <ion-skeleton-text animated class="home-credits-skeleton__pocket"></ion-skeleton-text>
            <ion-skeleton-text animated class="home-credits-skeleton__pocket"></ion-skeleton-text>
          </div>
          <ion-skeleton-text animated
            class="home-credits-skeleton__line home-credits-skeleton__line--hint"></ion-skeleton-text>
        </article>
        }
      </section>

      <section class="home-nav">
        <div class="home-nav-grid re-action-grid">
          <ion-card class="home-nav-card re-action-card" [button]="true" routerLink="/inn">
            <ion-card-content>
              <div class="home-nav-card__icon re-action-card__icon re-action-card__icon--amber">
                <ion-icon name="storefront-outline" aria-hidden="true"></ion-icon>
              </div>
              <p class="home-nav-card__title re-action-card__title">{{ 'common.inn' | translate }}</p>
              <p class="home-nav-card__desc re-action-card__description">{{ 'homePage.innDesc' | translate }}</p>
            </ion-card-content>
          </ion-card>
        </div>
      </section>

      <aside class="home-recent">
        <p class="home-section-label re-section-label">{{ 'profile.recentChats' | translate }}</p>

        @if (visibleRecentChats().length > 0) {
        <div class="home-recent-list">
          @for (chat of visibleRecentChats(); track chat.chatId; let first = $first) {
          <a class="home-recent-chat" [class.home-recent-chat--featured]="first" [routerLink]="chat.route">
            <span class="home-recent-chat__icon" aria-hidden="true">
              <ion-icon [name]="recentChatIcon(chat.kind)"></ion-icon>
            </span>
            <span class="home-recent-chat__body">
              @if (first) {
              <span class="home-recent-chat__eyebrow">{{ 'homePage.recentContinue' | translate }}</span>
              }
              <span class="home-recent-chat__title">
                @if (recentChatTitleKey(chat.kind); as titleKey) {
                {{ titleKey | translate }}
                } @else {
                {{ chat.chatName }}
                }
              </span>
              <span class="home-recent-chat__meta">
                @if (chat.storyName) {
                {{ chat.storyName }}
                } @else if (chat.kind === 'inn') {
                {{ 'common.inn' | translate }}
                }
                @if (recentChatTypeKey(chat.kind); as typeKey) {
                @if (chat.storyName || chat.kind === 'inn') {
                <span aria-hidden="true"> · </span>
                }{{ typeKey | translate }}
                }
              </span>
            </span>
            <span class="home-recent-chat__time">{{ chat.openedAt | date: 'd MMM' }}</span>
          </a>
          }
        </div>
        } @else {
        <div class="home-recent-empty re-empty-state re-empty-state--compact">
          <div class="home-recent-empty__icon re-empty-state__icon" aria-hidden="true">
            <ion-icon name="chatbubbles-outline"></ion-icon>
          </div>
          <p class="home-recent-empty__title re-empty-state__title">{{ 'homePage.recentEmpty' | translate }}</p>
          <p class="home-recent-empty__hint re-empty-state__description">{{ 'homePage.recentEmptyHint' | translate }}
          </p>
        </div>
        }
      </aside>
    </div>
  </div>
</ion-content>